import { PROJECT_SECTIONS, type ProjectDoc, type ProjectSection } from '@tomo/core';
import { Shapes, Vote } from 'lucide-react';
import type { ReactNode } from 'react';
import { useMeta } from '../../data/hooks.tsx';

/**
 * The two parts of a project that aren't collections. Everything else a project holds is a
 * collection, so it's added with New collection and there is no limit on how many you keep.
 */
export interface SectionInfo {
  id: ProjectSection;
  label: string;
  /** What it gives you, shown in the add menu. */
  hint: string;
  icon: ReactNode;
}

export const SECTIONS: Record<ProjectSection, SectionInfo> = {
  boards: { id: 'boards', label: 'Boards', hint: 'Notes, sketches, shapes and images.', icon: <Shapes /> },
  votes: { id: 'votes', label: 'Votes', hint: 'Polls for decisions the team makes together.', icon: <Vote /> },
};

export function addSection(project: ProjectDoc, id: ProjectSection): void {
  project.setSection(id, true);
}

/** Which sections the project doesn't have yet, in the order they appear in the add menu. */
export function useMissingSections(): SectionInfo[] {
  const meta = useMeta();
  return PROJECT_SECTIONS.filter((s) => !meta.sections.includes(s)).map((s) => SECTIONS[s]);
}
